export const ISRAEL_REGULATIONS_ROUTE = '/org/regulations';
export const WORLD_REGULATIONS_ROUTE = '/outreach/regulations';
